import { Api } from "../config/request";

export default {
  bulkUploadTropLocalityProperty(payload) {
    return Api.post("/property/trip-locality/bulk/upload", payload);
  },
};
